// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.inline-text {
  display: inline-block;
}

.lower-case {
  text-transform: lowercase;
}

ion-icon {
  margin-right: 5px;
  font-size: 2em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/contact-support/contact-support.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACI,iBAAA;EACA,cAAA;AACJ","sourcesContent":[".center-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inline-text {\n  display: inline-block;\n}\n\n.lower-case {\n  text-transform: lowercase;\n}\n\nion-icon{\n    margin-right: 5px;\n    font-size: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
